"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IVaultController__factory = exports.IStableCoin__factory = exports.ISavingsVault__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var ISavingsVault__factory_1 = require("./ISavingsVault__factory");
Object.defineProperty(exports, "ISavingsVault__factory", { enumerable: true, get: function () { return ISavingsVault__factory_1.ISavingsVault__factory; } });
var IStableCoin__factory_1 = require("./IStableCoin__factory");
Object.defineProperty(exports, "IStableCoin__factory", { enumerable: true, get: function () { return IStableCoin__factory_1.IStableCoin__factory; } });
var IVaultController__factory_1 = require("./IVaultController__factory");
Object.defineProperty(exports, "IVaultController__factory", { enumerable: true, get: function () { return IVaultController__factory_1.IVaultController__factory; } });
